import React from "react";

const IsLoading = () => {
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ width: "100vw", height: "60vh" }}
    >
      <span
        className="spinner spinner-border spinner-border-lg"
        style={{ width: 70, height: 70 }}
      ></span>
    </div>
  );
};

export default IsLoading;
